
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-dog fa-w-16 fa-3x",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"dog","data-prefix":"fal","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M288.12 32C279.89 32 272 38.39 272 48.03V224h-22.225l37.66 34.344L384 282.48v63.922l32 29.182V240h32c35.35 0 64-28.65 64-64v-64c0-8.84-7.16-16-16-16h-64l-7.16-14.31A32 32 0 00396.22 64H326.6l-27.28-27.28c-3.26-3.26-7.27-4.72-11.2-4.72zM304 86.66l9.34 9.34h82.88l16 32H480v48c0 17.64-14.36 32-32 32h-64v41.52l-80-20V86.66zM368 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zM16 176c-8.84 0-16 7.16-16 16 0 43.24 34.53 78.36 77.46 79.74C69.12 285.97 64 302.32 64 320v160c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96h96v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-14.87l-32-29.18V480h-64V377.588L291.941 352H160v128H96V320c0-35.29 28.71-64 64-64h26.67l-34.711-31.652c-16.516 1.384-31.82 6.975-44.908 15.652H80c-26.47 0-48-21.53-48-48 0-8.84-7.16-16-16-16z"}}),_c('path',{attrs:{"d":"M9.132 77.945l28.328-31.86 465.2 423.677-28.327 31.86z","opacity":".99"}})])
          )
        }
      }
    